
// Leaderboards. Display names live in the translation files under
// `leaderboards.<tag>.name` / `leaderboards.<tag>.short`.
const leaderboard = [
    {tag: "padel_t", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "padel_f", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "padel_m", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "padel_e", content: null, lb_type: 0, value: (x) => `P${x.value}`},
    {tag: "club_f", content: null, lb_type: 1, value: (x) => x.value},
    {tag: "club_t", content: null, lb_type: 1, value: (x) => x.value},
]

// Filters are keyed by a language neutral key -> backend value.
// Labels are resolved at render time (see components/FilterButton.js).
const constants = {
    "BACKEND": "/api/v2",
    "LEADERBOARD": leaderboard,
    "SHOW_ADS": false,
    "FILTERS": {
        "CATEGORY": {"M": "M", "V": "V", "V13": "V13", "M13": "M13", "V11": "V11", "M11": "M11", "U09": "U09"},
        "RANK": {"50": 50, "100": 100, "200": 200, "300": 300, "400": 400, "500": 500, "700": 700, "1000": 1000}
    }
}

export default constants;
